export default "__VITE_ASSET__CJEHcB6G__"